// extracted by mini-css-extract-plugin
module.exports = {"base":"Tabs_base__1r86v","Item":"Tabs_Item__2T635","Container":"Tabs_Container__46hGQ","ItemsWrapper":"Tabs_ItemsWrapper__37EnV","selected":"Tabs_selected__3vSjN"};